import {
  ApiParams,
  BaseClient,
  IActionResponse,
  IActionResult,
  IPagedResult,
} from "../../../assets/utils/lib";
import {
  LookupDto,
  QuestionnaireRequestPushNotificationDto,
  RequestPushNotificationDto,
  RequestPushNotificationGridDto,
  SearchRequestPushNotificationDto,
} from "../../dto";

export class PushNotificationClient extends BaseClient {
  routes = ["pophub", "PushNotification"];

  async getPushNotificationAsync(
    id: string | undefined,
  ): Promise<RequestPushNotificationDto> {
    const actions: string[] = ["GetPushNotification"];
    const params: ApiParams[] = [new ApiParams("Id", id, true)];

    const result: RequestPushNotificationDto =
      await this.getAsync<RequestPushNotificationDto>(actions, params);
    return result;
  }

  async searchPushNotificationAsync(
    payload: SearchRequestPushNotificationDto | undefined,
  ): Promise<IPagedResult<RequestPushNotificationGridDto>> {
    const actions: string[] = ["SearchPushNotification"];
    const result: IPagedResult<RequestPushNotificationGridDto> =
      await this.postAsync<
        SearchRequestPushNotificationDto,
        RequestPushNotificationGridDto,
        IPagedResult<RequestPushNotificationGridDto>
      >(actions, payload);
    return result;
  }

  async savePushNotificationAsync(
    payload: RequestPushNotificationDto | undefined,
  ): Promise<IActionResult<RequestPushNotificationDto>> {
    const actions: string[] = ["SavePushNotification"];
    return await this.postAsync<RequestPushNotificationDto>(actions, payload);
  }

  async cancelPushNotificationAsync(
    id?: string | undefined,
  ): Promise<IActionResponse> {
    const actions: string[] = ["CancelPushNotification"];
    const params: ApiParams[] = [new ApiParams("requestId", id, true)];

    return await this.deleteAsync(actions, params);
  }

  async deletePushNotificationAsync(
    id?: string | undefined,
  ): Promise<IActionResponse> {
    const actions: string[] = ["DeletePushNotification"];
    const params: ApiParams[] = [new ApiParams("requestId", id, true)];

    return await this.deleteAsync(actions, params);
  }

  async getLookupsAsync(): Promise<{
    communities: LookupDto[];
    userCommunities: LookupDto[];
    notificationType: LookupDto[];
    pageLink: LookupDto[];
    zipCodes: LookupDto[];
  }> {
    const actions: string[] = ["GetPushNotificationLookups"];
    const result = await this.getAsync<{
      communities: LookupDto[];
      userCommunities: LookupDto[];
      notificationType: LookupDto[];
      pageLink: LookupDto[];
      zipCodes: LookupDto[];
    }>(actions, []);
    return result;
  }

  async saveQuestionnairePushNotificationAsync(
    payload: QuestionnaireRequestPushNotificationDto,
  ): Promise<IActionResult<QuestionnaireRequestPushNotificationDto>> {
    const actions: string[] = ["SaveQuestionnairePushNotification"];
    return await this.postAsync<QuestionnaireRequestPushNotificationDto>(
      actions,
      payload,
    );
  }
}
